<!--
 * @Author: LiuMeiYu
 * @Date: 2023-02-02 09:45:43
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2023-03-15 16:02:04
 * @FilePath: \nivara\src\views\wallet\components\withdrawaRecordView.vue
 * @Description: *
 * *
 * Copyright (c) 2023 by yihua, All Rights Reserved.
-->
<template>
  <div class="withdraw-record-container" v-loading="userWalletLogLoading">
    <el-table
      class="withdraw-record-table"
      :data="withdrawRecordTableData"
      :header-cell-style="headerCellStyle"
      border
    >
      <el-table-column
        label="OrderNumber"
        prop="log_id"
        align="center"
      ></el-table-column>
      <el-table-column label="CreationTime" prop="create_time" align="center">
        <template #default="scope">
          {{
            $filters.DateFormatPipe(
              scope.row.create_time,
              "yyyy-MM-dd HH:mm:ss"
            )
          }}
        </template>
      </el-table-column>
      <el-table-column
        label="Amount"
        prop="amount"
        align="center"
      ></el-table-column>
      <el-table-column
        label="State"
        prop="order_status"
        align="center"
      ></el-table-column>
      <el-table-column label="Operation" align="center">
        <template #default="scope">
          <el-button
            class="btn-record-more"
            type="text"
            @click="lookRecordDetails(scope.row.log_id)"
            v-if="scope.row.order_status !== 'Pending'"
            >More</el-button
          >
          <div class="btn-record-more" type="text" v-else>-</div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="withdraw-record-pagination"
      background
      hide-on-single-page
      layout="total, prev, pager, next"
      :page-size="10"
      :total="withdrawRecordTotal"
      @current-change="withdrawRecordPaginationCurrentChange"
    />
    <Popup title="Log Details" ref="withdrawRecordDetailsRef">
      <template #content>
        <div class="record-details-content">
          <el-form :model="withdrawRecordDetailsData" label-position="top">
            <el-form-item label="Remarks" required>
              <el-input v-model="withdrawRecordDetailsData.remark" disabled />
            </el-form-item>
            <el-form-item label="Remiitance picture" required>
              <el-image
                :src="withdrawRecordDetailsData.image"
                v-if="withdrawRecordDetailsData.image"
              />
              <div v-else>NO Remiitance picture</div>
            </el-form-item>
          </el-form>
          <el-button @click="withdrawRecordDetailsRef.close()">OK</el-button>
        </div>
      </template>
    </Popup>
  </div>
</template>
<script>
import {
  defineComponent,
  nextTick,
  onMounted,
  reactive,
  ref,
  toRefs,
} from "@vue/runtime-core";
import {
  getUserWalletLogApi,
  getUserWalletLogDetailApi,
} from "../../../api/index";
import Popup from "../../../components/popupView.vue";

export default defineComponent({
  name: "Wallet",
  components: { Popup },
  setup() {
    onMounted(() => {
      getUserWalletLog();
    });
    const walletType = ref(0);
    const withdrawRecordPage = ref(0);
    const withdrawRecordTotal = ref(0);
    const withdrawRecordDetailsRef = ref(null);
    const state = reactive({
      withdrawRecordTableData: [],
      headerCellStyle: {
        "background-color": "#DFDFDF",
        "font-weight": "500",
        color: "#000000",
      },
      withdrawRecordDetailsData: {},
    });
    const lookRecordDetails = (logId) => {
      console.log(logId);
      getUserWalletLogDetail(logId);
    };
    const withdrawRecordPaginationCurrentChange = (e) => {
      withdrawRecordPage.value = e - 1;
      nextTick(() => {
        getUserWalletLog();
      });
    };
    const getUserWalletLogDetail = (logId) => {
      let data = {
        token: localStorage.getItem("token"),
        log_id: logId,
      };
      getUserWalletLogDetailApi(data).then((res) => {
        console.log("getUserWalletLogDetailApi", res);
        if (res.data.success && res.data.data) {
          state.withdrawRecordDetailsData = res.data.data;
          nextTick(() => {
            withdrawRecordDetailsRef.value.open();
          });
        }
      });
    };
    const userWalletLogLoading = ref(false);
    const getUserWalletLog = () => {
      userWalletLogLoading.value = true;
      let data = {
        token: localStorage.getItem("token"),
        page: withdrawRecordPage.value,
        type: "all",
      };
      getUserWalletLogApi(data).then((res) => {
        console.log("getUserWalletLogApi：", res);
        if (res.data.success) {
          if (res.data.data.length > 0) {
            state.withdrawRecordTableData = res.data.data;
          }
          if (res.data.total) {
            withdrawRecordTotal.value = res.data.total;
          } else {
            withdrawRecordTotal.value = 0;
          }
          userWalletLogLoading.value = false;
        } else {
          userWalletLogLoading.value = false;
        }
      });
    };
    return {
      walletType,
      withdrawRecordTotal,
      withdrawRecordDetailsRef,
      lookRecordDetails,
      withdrawRecordPaginationCurrentChange,
      userWalletLogLoading,
      ...toRefs(state),
    };
  },
});
</script>

<style lang="less" scoped>
.withdraw-record-container {
  .withdraw-record-table {
    border-radius: 12px;
    .btn-record-more {
      color: #2d43bf !important;
    }
  }
  .withdraw-record-pagination {
    margin-top: 20px;
    :deep(.el-icon-arrow-left) {
      margin: 0 10px;
    }
    :deep(.el-icon-arrow-right) {
      margin: 0 10px;
    }
  }

  .record-details-content {
    padding: 20px;
    .el-button {
      background-color: #03004d;
      color: #ffffff;
      border-radius: 12px;
    }
  }
}
</style>
